/* XC TORVAULT ヘッダー — SPメニュー / アクティブナビ / 任意コンパクト化 */
(function () {
  'use strict';
  if (window.__xcTvhInit) return;
  window.__xcTvhInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-xc-tvh]');
    if (!root) return;

    /* ---------- SPメニュー ---------- */
    var burger = root.querySelector('[data-xc-tvh-burger]');
    var menu = root.querySelector('[data-xc-tvh-menu]');
    var lastFocus = null;

    function openMenu() {
      lastFocus = document.activeElement;
      menu.hidden = false;
      burger.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () {
        menu.classList.add('is-open');
        var first = menu.querySelector('a');
        if (first) first.focus();
      });
    }
    function closeMenu() {
      burger.setAttribute('aria-expanded', 'false');
      menu.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      var done = function () { menu.hidden = true; };
      if (reduced) done(); else setTimeout(done, 220);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    if (burger && menu) {
      burger.addEventListener('click', function () {
        if (burger.getAttribute('aria-expanded') === 'true') closeMenu(); else openMenu();
      });
      menu.addEventListener('click', function (e) {
        if (e.target.closest('[data-xc-tvh-menulink]')) closeMenu();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') closeMenu();
      });
    }

    /* ---------- カート点数バッジ ---------- */
    var cartBtn = root.querySelector('[data-xc-cart-btn]');
    var cartCount = root.querySelector('[data-xc-cart-count]');
    function setCartCount(n) {
      if (!cartCount) return;
      cartCount.textContent = n;
      cartCount.hidden = !(n > 0);
      if (cartBtn) cartBtn.setAttribute('aria-label', 'カートを見る(' + n + '点入っています)');
      cartCount.classList.add('is-bump');
      setTimeout(function () { cartCount.classList.remove('is-bump'); }, 220);
    }
    if (cartCount && window.fetch) {
      document.addEventListener('xc:cart:count', function (e) {
        setCartCount(e.detail && typeof e.detail.count !== 'undefined' ? e.detail.count : 0);
      });
      document.addEventListener('xc:cart:added', function () {
        fetch('/cart.js').then(function (r) { return r.json(); })
          .then(function (c) { setCartCount(c.item_count); }).catch(function () {});
      });
      fetch('/cart.js').then(function (r) { return r.json(); })
        .then(function (c) { if (c.item_count > 0) { cartCount.textContent = c.item_count; cartCount.hidden = false; } })
        .catch(function () {});
    }

    /* ---------- アクティブナビ(設定ON時のみ) ---------- */
    if (root.hasAttribute('data-xc-tvh-activenav') && 'IntersectionObserver' in window) {
      var links = Array.prototype.slice.call(root.querySelectorAll('[data-xc-tvh-link]'));
      var map = {};
      var targets = [];
      links.forEach(function (a) {
        var id = (a.getAttribute('href') || '').replace(/^.*#/, '');
        var el = id && document.getElementById(id);
        if (el) { map[id] = a; targets.push(el); }
      });
      if (targets.length) {
        var setCurrent = function (id) {
          links.forEach(function (a) { a.removeAttribute('aria-current'); });
          if (id && map[id]) map[id].setAttribute('aria-current', 'true');
        };
        var visible = {};
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { visible[en.target.id] = en.isIntersecting; });
          var current = null;
          for (var i = 0; i < targets.length; i++) {
            if (visible[targets[i].id]) { current = targets[i].id; break; }
          }
          setCurrent(current);
        }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });
        targets.forEach(function (t) { io.observe(t); });
      }
    }

    /* ---------- コンパクト化(設定ON時のみ) ---------- */
    if (root.classList.contains('xc-torvault-header--compactable')) {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          root.classList.toggle('is-compact', window.scrollY > 120);
          ticking = false;
        });
      }, { passive: true });
    }
  });
})();
